module.exports = __webpack_public_path__ + "img/home_bg3.79d4ece5.jpg";